import baseURL from "../common/axios";
class Commonservices {
  createIndentTemplate(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("IndentTemplate/Create", data);
  }

  updateIndentTemplate(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("IndentTemplate/Update", data);
  }

  GetIndentTemplate(HospitalId, BranchId, FromStoreId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IndentTemplate/List/StartDate/EndDate/PageNum/PageSize?HospitalId=" +
        HospitalId +
        "&BranchId=" +
        BranchId +
        "&FromStoreId=" +
        FromStoreId +
        ""
    );
  }

  GetStockWOTMCustom(
    startDate,
    endDate,
    PageSize,
    PageNum,
    docType,
    columnName,
    columnValue,
    columnName1,
    columnValue1,
    columnName2,
    columnValue2,
    Flag,
    SearchOption,
    columnName3,
    columnValue3,
    Condition
  ) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/ListStockWOTransTM/StartDate/EndDate/PageNum/PageSize?startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&pageSize=" +
        PageSize +
        "&pageNum=" +
        PageNum +
        "&DocType=" +
        docType +
        "&columnName=" +
        columnName +
        "&columnValue=" +
        columnValue +
        "&columnName1=" +
        columnName1 +
        "&columnValue1=" +
        columnValue1 +
        "&columnName2=" +
        columnName2 +
        "&columnValue2=" +
        columnValue2 +
        "&columnName3=" +
        columnName3 +
        "&columnValue3=" +
        columnValue3 +
        "&Flag=" +
        Flag +
        "&SearchOption=" +
        SearchOption +
        "&Condition=" +
        Condition +
        ""
    );
  }

  // GetStockWOTM(
  //   startDate,
  //   endDate,
  //   PageSize,
  //   PageNum,
  //   docType,
  //   columnName,
  //   columnValue,
  //   columnName1,
  //   columnValue1
  // ) {
  //   return baseURL.httpMSInventoryUrl.get(
  //     "StockWOTransTM/List/StartDate/EndDate/PageNum/PageSize?startDate=" +
  //       startDate +
  //       "&endDate=" +
  //       endDate +
  //       "&pageSize=" +
  //       PageSize +
  //       "&pageNum=" +
  //       PageNum +
  //       "&DocType=" +
  //       docType +
  //       "&columnName=" +
  //       columnName +
  //       "&columnValue=" +
  //       columnValue +
  //       "&columnName1=" +
  //       columnName1 +
  //       "&columnValue1=" +
  //       columnValue1 +
  //       ""
  //   );
  // }

  ListPOByPIId(startDate, endDate, PageSize, PageNum, docType, RefId) {
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/ListPOByPIId?startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&pageSize=" +
        PageSize +
        "&pageNum=" +
        PageNum +
        "&DocType=" +
        docType +
        "&RefId=" +
        RefId +
        ""
    );
  }

  DeleteIndentTemplate(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete(
      "IndentTemplate/Delete?Id=" + data
    );
  }

  GetIdStockWOTM(data) {
    return baseURL.httpMSInventoryUrl.get("StockWOTransTM/Get?id=" + data);
  }

  createIndentTemplateDetails(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "IndentTemplateDetails/Create",
      data
    );
  }

  updateIndentTemplateDetails(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "IndentTemplateDetails/Update",
      data
    );
  }

  getStockWODetails(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.get("StockWODetailsTD/Get?id=" + data);
  }

  GetByStockWOTransByRefId(RefId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetByStockWOTransByRefId?RefId=" + RefId
    );
  }

  UpdateStatusStockWODetailsTD(PRDetailsarr) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "StockWODetailsTD/StatusChange",
      PRDetailsarr
    );
  }

  GetByIndentTemplateId(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IndentTemplate/GetByIndentTemplateId?id=" + data
    );
  }

  ListGetByRefId(RefId, Type) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWODetailsTD/ListGetByRefId?RefId=" + RefId + "&DocType=" + Type
    );
  }

  GetStockWOTMTableList(docType, StoreId, type, HospitalId) {
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetListByDocType?DocType=" +
        docType +
        "&StoreId=" +
        StoreId +
        "&type=" +
        type +
        "&HospitalId=" +
        HospitalId
    );
  }

  FileListByStoreId(StoreId, BranchId) {
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/FileListByStoreId?StoreId=" +
        StoreId +
        "&BranchId=" +
        BranchId
    );
  }

  GetUnitRateByPO(DocType, StoreId, SupplierId, ItemId) {
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetUnitRateByPO?DocType=" +
        DocType +
        "&StoreId=" +
        StoreId +
        "&SupplierId=" +
        SupplierId +
        "&ItemId=" +
        ItemId
    );
  }

  GetStockOutTMTableList(docType, StoreId, type) {
    return baseURL.httpMSInventoryUrl.get(
      "StockOutMasterTM/GetListByDocType?DocType=" +
        docType +
        "&StoreId=" +
        StoreId +
        "&type=" +
        type
    );
  }

  GetRequestIDs(requestId, flag, status, DocType, StoreBrMapId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Custom/ListStockWOTransTMByToStoreId?id=" +
        requestId +
        "&flag=" +
        flag +
        "&status=" +
        status +
        "&DocType=" +
        DocType +
        "" +
        "&StoreBrMapId=" +
        StoreBrMapId
    );
  }

  GetRequestedItems(requestId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Custom/GetRequestItems?id=" + requestId + ""
    );
  }

  GetItemsByRequstId(requestId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Custom/GetItemsByRequstId?id=" + requestId + ""
    );
  }

  GetItemsByRequstIdCustom(requestId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Custom/GetItemsByRequstIdCustom?id=" + requestId + ""
    );
  }
  GetPickListByRequestId(requestId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Custom/GetPickListByRequestId?id=" + requestId + ""
    );
  }
  UpdatePickStatus(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "StockWOTransTM/UpdatePickStatus",
      data
    );
  }

  GetItemsByRequstIdForPIPR(requestId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Custom/GetItemsByRequstIdForPIPR?id=" + requestId + ""
    );
  }

  GetAutoRequestItemByIndentId(requestId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "IndentTemplate/GetAutoRequestItemByIndentId?id=" + requestId + ""
    );
  }

  GetFreqRequestItemByRequestId(requestId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetFreqRequestItemByRequestId?id=" + requestId + ""
    );
  }

  GetItemsByIssueIdDocType(IssueId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockOutMasterTM/GetByStockOutId?id=" + IssueId + ""
    );
  }

  GetPIList() {
    return baseURL.httpMSInventoryUrl.get("Custom/ListStockWOTransTMCustom");
  }

  GetPIItemList(PIId) {
    return baseURL.httpMSInventoryUrl.get("Custom/GetPIItems?id=" + PIId + "");
  }

  deleteStockWoDetails(data) {
    return baseURL.httpMSInventoryUrl.delete(
      "StockWODetailsTD/Delete?Id=" + data
    );
  }

  deleteIndentTemplateDetailsCustom(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete(
      "IndentTemplateDetails/DeleteCustom?Id=" + data
    );
  }

  deleteStockOutDetails(data) {
    return baseURL.httpMSInventoryUrl.delete(
      "StockOutDetailsTD/Delete?Id=" + data
    );
  }

  StockWOOutStatusChanged(ObjCancelPO) {
    debugger;

    return baseURL.httpMSInventoryUrl.post(
      "StockWOTransTM/StockWOOutStatusChanged",
      ObjCancelPO
    );
  }

  UpdateCloseStatus(ObjClosed) {
    debugger;

    return baseURL.httpMSInventoryUrl.post(
      "StockWOTransTM/UpdateCloseStatus",
      ObjClosed
    );
  }

  GetReOrderLevelList(StoreId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ItemStoreMappingMAP/GetReOrderLevelItem?StoreId=" + StoreId
    );
  }

  GetAutoRequestIds(StoreId, Type) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetAutoRequestIds?StoreId=" + StoreId + "&Type=" + Type
    );
  }

  GetListByDocNo(DocNo, StoreId, DocType) {
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetListByDocNo?DocNo=" +
        DocNo +
        "&StoreId=" +
        StoreId +
        "&DocType=" +
        DocType
    );
  }

  UpdateApprovalStatus(EntityTransactionId, IsApproved) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "StockWOTransTM/UpdateApprovalStatus?EntityTransactionId=" +
        EntityTransactionId +
        "&IsApproved=" +
        IsApproved
    );
  }

  ExportSendMail(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("Common/ExportSendMail", data);
  }

  GetStockWODetailsById(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetStockWODetailsById?id=" + data
    );
  }
}

export default new Commonservices();
